import { Component, computed, input, type Signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JssModule, type TextField } from '@sitecore-jss/sitecore-jss-angular';
import type { MultiPriceStoreProductData } from '@innogy/feh/models';

import { PriceInfoComponent } from '../price-info/price-info.component';
import { getProductSuffixLabel } from '../../utils/get-product-suffix-label';
import type { StoreProductOverviewFieldsData } from '../../models/store-product-overview-rendering.interface';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'eplus-price-info-container',
  templateUrl: './price-info-container.component.html',
  styleUrl: './price-info-container.component.scss',
  standalone: true,
  imports: [PriceInfoComponent, CommonModule, JssModule],
})
export class PriceInfoContainerComponent {
  public readonly product = input.required<MultiPriceStoreProductData>();
  public readonly fields = input.required<StoreProductOverviewFieldsData>();

  protected readonly suffixLabel: Signal<TextField> = computed(() => {
    return getProductSuffixLabel(
      this.product(),
      this.fields().ProductPriceSuffixLabel
    );
  });
}
